import {
    cssVal,
    getDataByCodePostal, getDataBySiren, hidden,
    newInput,
    tryToDate, visible,
} from "@/data/helpers";
import {def} from "@/data/dictionnaire";

export const avecChangementGreffeMemeDepartement = {
    title: "Transferts de siège : avec changement de greffe même département",
    texte: "<strong>{{societeGroup.societeDenomination}}</strong>[[ ({{societeGroup.sigle}})]] {{societeGroup.societeFormeJuridique}}, au capital de {{societeGroup.societeCapital}} €, Siège : {{siegeSocialGroup.societeAdresse}}[[, " +
        "{{siegeSocialGroup.societeAdresse2}}]] {{siegeSocialGroup.societeCodePostal}} {{siegeSocialGroup.societeVille}}, RCS : <span style='text-transform: uppercase'>{{societeGroup.societeRcsVille}}</span> N° {{societeGroup.societeRcs}}. <br>" +
        "Aux termes {{acteGroup.auTermeAssembleDecisionActe}} en date du {{acteGroup.dateDu}}, le siège social a été transféré au {{nouveauSiegeGroup.adresse}}[[ {{nouveauSiegeGroup.adresseSuite}}]] {{nouveauSiegeGroup.codePostal}} {{nouveauSiegeGroup.ville}}, et ce à compter du {{acteGroup.changementACompterDu}}. {{representantLegalGroup.typeRepresentant}} : {{representantLegalGroup.prenom}} {{representantLegalGroup.nom}}, {{representantLegalGroup.adresse}} [[{{representantLegalGroup.adresseSuite}}]] {{representantLegalGroup.codePostal}} {{representantLegalGroup.ville}}[[, {{corepresentantLegalGroup.typeRepresentant}} : {{corepresentantLegalGroup.prenom}} {{corepresentantLegalGroup.nom}}, {{corepresentantLegalGroup.adresse}} [[{{corepresentantLegalGroup.adresseSuite}}]] {{corepresentantLegalGroup.codePostal}} {{corepresentantLegalGroup.ville}}]]. Formalités au RCS {{nouveauSiegeGroup.formaliteAuRcs}}.",                                                                                                              //
    script: (text, varText, attribute) => {
        let tmpText = "";
        switch (attribute) {
            case "acteGroup.auTermeAssembleDecisionActe":
                if(varText['acteGroup.auTermeAssembleDecisionActe'] === 'd\'un acte reçu par Me') {
                    tmpText = 'reçu par Me '+ cssVal(varText['acteGroup.nomNotaire']) +" notaire à "+ cssVal(varText['acteGroup.lieuNotaire']);
                } else {
                    tmpText = cssVal(varText['acteGroup.auTermeAssembleDecisionActe']);
                }
                break;
            case "acteGroup.changementACompterDu":
            case "acteGroup.dateDu":
                tmpText = cssVal(tryToDate(varText[attribute]));
                break;
            default:
                return undefined;
        }
        return tmpText;
    },
    model: {
        societeGroup: [{}],
        ancienSiegeGroup: [{}],
        nouveauSiegeGroup: [{}],
        representantLegalGroup: [{}],
        corepresentantLegalGroup: [{}],
    },
    schema: [
        {
            //0
            name: "societeGroup",
            label: "Société",
            type: "group",
            value: [{}],
            children: [
                newInput(def.rcs, '_required', {name: 'societeRcs',
                        on: {
                            change: async (val) => {
                                val = val.target.value.replaceAll(' ', '');
                                if (val.length !== 9) {
                                    return false;
                                }

                                const data = await getDataBySiren(val);
                                if(Object.keys(data).length === 0) {
                                    return false;
                                }

                                avecChangementGreffeMemeDepartement.model.societeGroup[0] = data.values.societe;
                                avecChangementGreffeMemeDepartement.model.siegeSocialGroup[0] = data.values.siegeSocial;

                                const dataCP = await getDataByCodePostal(data.values.siegeSocial.societeCodePostal, data.values.siegeSocial.ville);
                                avecChangementGreffeMemeDepartement.schema[1].children[3].options = dataCP.options;
                                avecChangementGreffeMemeDepartement.model.siegeSocialGroup[0].societeVille = dataCP.ville_slug;
                            }
                        }
                    }
                ),
                newInput(def.lieuImmatriculation, '_required', {name: 'societeRcsVille'}),
                newInput(def.denomination, '_required', {name: 'societeDenomination'}),
                newInput(def.sigle),
                newInput(def.formesSocietes, '_required', {name: 'societeFormeJuridique'}),
                newInput(def.montantCapital, '_required', {name: 'societeCapital'}),
            ]
        },
        {
            //1
            name: "siegeSocialGroup",
            label: "Ancien siège",
            type: "group",
            value: [{}],
            children: [
                newInput(def.adresse, '_required', {name: 'societeAdresse'}),
                newInput(def.adresseSuite, '_required', {name: 'societeAdresse2'}),
                newInput(def.codePostal, '_required', {
                    name: 'societeCodePostal',
                    on: {
                        change: async (val) => {
                            val = val.target.value;
                            if (val.length !== 5) {
                                return false;
                            }

                            const data = await getDataByCodePostal(val);

                            if(Object.keys(data).length === 0) {
                                return false;
                            }

                            avecChangementGreffeMemeDepartement.schema[1].children[3].options = data.options;
                            avecChangementGreffeMemeDepartement.model.ancienSiegeGroup[0].societeVille = data.ville_slug;
                            avecChangementGreffeMemeDepartement.model.societeGroup[0].societeRcsVille = data.greffe;
                        }
                    }
                }),
                newInput(def.ville, '_validUniqueSelect', {name: 'societeVille'}),
            ]
        },
        {
            //2
            name: "acteGroup",
            label: "Acte",
            type: "group",
            value: [{}],
            children: [
                newInput(def.auTermeAssembleDecisionActe, '_required', {
                    on: {
                        input: (val) => {
                            avecChangementGreffeMemeDepartement.schema[2].children[1] = val === "6" ? visible(avecChangementGreffeMemeDepartement.schema[2].children[1]) : hidden(avecChangementGreffeMemeDepartement.schema[2].children[1]);
                            avecChangementGreffeMemeDepartement.schema[2].children[2] = val === "6" ? visible(avecChangementGreffeMemeDepartement.schema[2].children[2]) : hidden(avecChangementGreffeMemeDepartement.schema[2].children[2]);
                        }
                    }
                }),
                newInput(def.nomNotaire, '_required', {}, 'hidden'),
                newInput(def.lieuNotaire, '_required', {}, 'hidden'),
                newInput(def.dateDu, '_required'),
                newInput(def.changementACompterDu, '_required'),
            ]
        },
        {
            //3
            name: "nouveauSiegeGroup",
            label: "Nouveau siège",
            type: "group",
            value: [{}],
            children: [
                newInput(def.adresse, '_required'),
                newInput(def.adresseSuite),
                newInput(def.codePostal, '_required', {
                    on: {
                        change: async (val) => {
                            val = val.target.value;
                            if (val.length !== 5) {
                                return false;
                            }

                            const data = await getDataByCodePostal(val);

                            if(Object.keys(data).length === 0) {
                                return false;
                            }

                            avecChangementGreffeMemeDepartement.schema[3].children[3].options = data.options;
                            avecChangementGreffeMemeDepartement.model.nouveauSiegeGroup[0].ville = data.ville_slug;
                            avecChangementGreffeMemeDepartement.model.nouveauSiegeGroup[0].formaliteAuRcs = data.greffe;
                        }
                    }
                }),
                newInput(def.ville, '_required'),
                newInput(def.formaliteAuRcs, '_required'),
            ]
        },
        {
            //4
            name: "representantLegalGroup",
            label: "Représentant légal",
            type: "group",
            value: [{}],
            children: [
                newInput(def.typeRepresentant, '_required'),
                newInput(def.nom, '_required'),
                newInput(def.prenom, '_required'),
                newInput(def.adresse, '_required'),
                newInput(def.adresseSuite),
                newInput(def.codePostal, '_required', {
                    on: {
                        change: async (val) => {
                            val = val.target.value;
                            if (val.length !== 5) {
                                return false;
                            }

                            const data = await getDataByCodePostal(val);

                            if(Object.keys(data).length === 0) {
                                return false;
                            }

                            avecChangementGreffeMemeDepartement.schema[4].children[6].options = data.options;
                            avecChangementGreffeMemeDepartement.model.representantLegalGroup[0].ville = data.ville_slug;
                        }
                    }
                }),
                newInput(def.ville, '_required'),
            ]
        },
        {
            //5
            label: "Ajouter un représentant",
            type: "button",
            on: {
                click: () => {
                    avecChangementGreffeMemeDepartement.schema[5].type = "hidden";
                    avecChangementGreffeMemeDepartement.schema[5].label = "";

                    avecChangementGreffeMemeDepartement.schema[6].type = "group";
                    avecChangementGreffeMemeDepartement.schema[6].label = "Représentant légal 2";

                    avecChangementGreffeMemeDepartement.schema[7].type = "button";
                    avecChangementGreffeMemeDepartement.schema[7].label = "Supprimer un représentant";
                }
            }
        },
        {
            //6
            name: "corepresentantLegalGroup",
            label: "",
            type: "hidden",
            value: [{}],
            children: [
                newInput(def.typeRepresentant, '_required'),
                newInput(def.nom, '_required'),
                newInput(def.prenom, '_required'),
                newInput(def.adresse, '_required'),
                newInput(def.adresseSuite),
                newInput(def.codePostal, '_required', {
                    on: {
                        change: async (val) => {
                            val = val.target.value;
                            if (val.length !== 5) {
                                return false;
                            }

                            const data = await getDataByCodePostal(val);

                            if(Object.keys(data).length === 0) {
                                return false;
                            }

                            avecChangementGreffeMemeDepartement.schema[6].children[6].options = data.options;
                            avecChangementGreffeMemeDepartement.model.corepresentantLegalGroup[0].ville = data.ville_slug;
                        }
                    }
                }),
                newInput(def.ville, '_required'),
            ]
        },
        {
            //7
            label: "",
            type: "hidden",
            on: {
                click: () => {
                    avecChangementGreffeMemeDepartement.schema[5].type = "button";
                    avecChangementGreffeMemeDepartement.schema[5].label = "Ajouter un représentant";

                    avecChangementGreffeMemeDepartement.schema[6].type = "hidden";
                    avecChangementGreffeMemeDepartement.schema[6].label = "";

                    avecChangementGreffeMemeDepartement.schema[7].type = "hidden";
                    avecChangementGreffeMemeDepartement.schema[7].label = "";
                }
            }
        },
    ]
}